/**
 * @fileoverview GET handler for the "/engagement/canvas/canvas_territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasCanvasTerritories } from "./constants";
import type { EngagementCanvasCanvasTerritoriesResult, EngagementCanvasCanvasTerritoriesParams } from "./types";

export const getEngagementCanvasCanvasTerritories = reactQueryFetcherAdapter(
  engagementCanvasCanvasTerritories,
  (
    signal: AbortSignal,
    { appGroupId }: EngagementCanvasCanvasTerritoriesParams
  ): Promise<EngagementCanvasCanvasTerritoriesResult> => {
    return fetch("/engagement/canvas/canvas_territories", "GET", { app_group_id: appGroupId }, { signal });
  }
);
